import { render, staticRenderFns } from "./BattleParticipants.vue?vue&type=template&id=80ba733c&scoped=true"
import script from "./BattleParticipants.vue?vue&type=script&lang=ts&setup=true"
export * from "./BattleParticipants.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BattleParticipants.vue?vue&type=style&index=0&id=80ba733c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ba733c",
  null
  
)

export default component.exports